/** The template whose repos are meta repos - keep in step with the workers repo. */
export const META_TEMPLATE = 'solutions-design-meta-template';

const META_SUFFIX = '-meta';

/**
 * Why a repository name is not acceptable, or undefined when it is. Mirrors the
 * worker's RepositoryNaming.FormatError so the form says the same thing the
 * worker would, but earlier. An empty name is not an error here: the field's own
 * `required` handling covers that.
 */
export const repositoryNameError = (
  name: string | undefined,
  isMeta: boolean,
): string | undefined => {
  if (!name) {
    return undefined;
  }
  if (!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(name)) {
    return 'repository name must be lower case letters, digits and single hyphens only';
  }
  if (name.includes('paradigm')) {
    return "repository name must not contain 'paradigm'; use 'shared' instead";
  }
  if (isMeta) {
    return name.endsWith(META_SUFFIX) && name.length > META_SUFFIX.length
      ? undefined
      : 'meta repository name must match pattern system-meta or system-servicegroup-meta';
  }
  return name.split('-').length >= 3
    ? undefined
    : 'repository name must match pattern system-servicegroup-service-{optional descriptor}';
};
